import React from 'react';
import '../../../../styles/sass/clients/clientTabs.scss';
import statuses, { colorStatus } from '../../../../constants/users/statuses';
import { Box, Typography } from '@mui/material';
import { WidgetClientData } from '../../../../components/widget/WidgetClientData';
import { useTranslation } from 'react-i18next';
import { WavyCheckSVG } from '../../../../components';
import { getColor } from '../../../../helpers/getColor';
import { palette } from '../../../../styles/theme';

export default function ClientData ({ data, client }) {
    const { t } = useTranslation();
    // Functions

    const fechaAlta = client?.created_at.slice(0, 10).split('-').reverse().join('/');
    // Main component

    return (
        <Box
            display='flex'
            flexDirection='row'
            alignItems='center'
            gap='24px'
            style={{ width: '1104px', height: '80px', padding: '24px 0' }}
        >
            <Box display='flex' flexDirection='row' alignItems='center' style={{ borderRight: `solid 2px ${getColor('primary', 700)}`, paddingRight: '24px' }}>
                <Box className='clientData--avatar'
                    bgcolor={'transparent !important'}
                    color={getColor('primary', 700) + ' !important'}
                    border={`solid 3px ${getColor('primary', 700)}`}
                ><span>{data?.avatar ? data.avatar : 'NN' }</span></Box>
                <Typography variant='h5' color={palette.primary.main}>{data.formattedName}</Typography>
                <Typography className='ClientStatus' style={colorStatus[data.status]} margin='0 8px' >{t(`clients.table.status.${statuses[data.status].id}`)} </Typography>
            </Box>
            <WidgetClientData title={t('clients.table.columns.document')} value={data.document}/>
            <WidgetClientData title={t('clients.table.columns.created')} value={fechaAlta}/>
            <WidgetClientData title={t('details.inputs.email')} value={data.email} icon={<WavyCheckSVG customFill={palette.success[500]} />} />
            <WidgetClientData title={t('clients.table.columns.phone')} value={data.telephone.replace('+549', '')} border={false} icon={<WavyCheckSVG customFill={palette.success[500]} />} />
        </Box>
    );
}
